import { Box, Typography } from '@mui/material';
import React from 'react';
import { Button } from '../Button';


export const DropdownFilterBlock: React.FC<{
  title: string;
  onReset: () => void;
  hasValue?: boolean;
  contentPadding?: boolean;
}> = (props) => {
  const [ opened, setOpened ] = React.useState(!!props.hasValue);

  if (!opened) {
    return (
      <Box p={2}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography color="textSecondary">{props.title}</Typography>
          <Button color="secondary" onClick={() => setOpened(true)}>Add</Button>
        </Box>
      </Box>
    );
  }

  return (
    <Box p={2}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography color="textSecondary">{props.title}</Typography>
        <Button color="secondary" onClick={props.onReset}>Reset</Button>
      </Box>
      <Box px={props.contentPadding === false ? 0 : 2}>
        {props.children}
      </Box>
    </Box>
  );
};
